import { render, staticRenderFns } from "./docpropstable.vue?vue&type=template&id=6efd4e0d&"
import script from "./docpropstable.vue?vue&type=script&lang=js&"
export * from "./docpropstable.vue?vue&type=script&lang=js&"
import style0 from "./docpropstable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports